import { useMemo, useState } from 'react';
import { getFeaturedMenu, getShopInfo } from './lib/twin';
import { buildLocalBusinessJsonLd } from './lib/seo';
import { useOpenStatus } from './hooks/useOpenStatus';
import { useJsonLd } from './hooks/useJsonLd';
import { Hero } from './components/splash/Hero';
import { HowItWorks } from './components/splash/HowItWorks';
import { FeaturedMenu } from './components/splash/FeaturedMenu';
import { HoursAndLocation } from './components/splash/HoursAndLocation';
import { AboutSection } from './components/splash/AboutSection';
import { SiteFooter } from './components/splash/SiteFooter';
import { StickyOrderBar } from './components/splash/StickyOrderBar';
import { BaristaBotPanel } from './components/splash/BaristaBotPanel';

export default function App() {
  // Grounded reads from the client-side Virtual Twin (localStorage-backed).
  const shop = useMemo(() => getShopInfo(), []);
  const featured = useMemo(() => getFeaturedMenu(6), []);
  const status = useOpenStatus();

  const [botOpen, setBotOpen] = useState(false);

  const jsonLd = useMemo(
    () => buildLocalBusinessJsonLd(shop, featured),
    [shop, featured],
  );
  useJsonLd(jsonLd);

  return (
    <>
      <a className="skip-link" href="#menu">
        Skip to menu
      </a>

      <header>
        <Hero shop={shop} status={status} onOpenBot={() => setBotOpen(true)} />
      </header>

      <main id="main">
        <HowItWorks onOpenBot={() => setBotOpen(true)} />
        <FeaturedMenu featured={featured} />
        <HoursAndLocation shop={shop} status={status} />
        <AboutSection shop={shop} />
      </main>

      <SiteFooter shop={shop} status={status} onOpenBot={() => setBotOpen(true)} />

      <StickyOrderBar status={status} onOpenBot={() => setBotOpen(true)} />

      {botOpen && (
        <BaristaBotPanel onClose={() => setBotOpen(false)} featured={featured} />
      )}
    </>
  );
}
